import {
  ColorPicker,
  DatePicker,
  Form,
  Input,
  QRCode,
  Select,
  Slider,
  Switch,
  TimePicker,
} from "antd"
import dayjs from "dayjs"
import { cloneElement, useState } from "react"

import Flex from "#blocks/Flex"
import DisabledFieldTooltip from "#blocks/Form/DisabledFieldTooltip"
import SearchBar from "#blocks/SearchBar"
import { disabledHours, getNow, STANDARD_TIME_FORMAT } from "#utils/dateHelpers"

import AntdSection from "./AntdSection"

const AntdForms = () => {
  const [selectValue, setSelectValue] = useState("task")

  return (
    <Flex col gap={20} style={{ paddingBottom: 40 }}>
      <AntdSection title="Inputs">
        <Form.Item label="Name" layout="vertical">
          <Input />
        </Form.Item>

        <Form.Item label="Disabled tooltip" layout="vertical">
          <DisabledFieldTooltip
            disabled
            tooltip="This field is disabled because..."
          >
            <Input disabled />
          </DisabledFieldTooltip>
        </Form.Item>

        <Select
          options={[
            { label: "Dropdown", value: "dropdown" },
            { label: "Dropdown 2", value: "dropdown2" },
          ]}
          onChange={(e) => setSelectValue(e)}
          value={selectValue}
          style={{ width: 200 }}
        />
      </AntdSection>

      <AntdSection title="Search">
        <Flex col gap={10}>
          <SearchBar
            onSearch={() => {}}
            placeholder="Search by name, date, email, etc"
          />
          <SearchBar onSearch={() => {}} loading placeholder="Loading..." />
        </Flex>
      </AntdSection>

      <AntdSection title="PIN">
        <Input.OTP value={"123"} mask={"*"} />
      </AntdSection>

      <AntdSection title="Date and time pickers">
        <Flex col gap={10}>
          <DatePicker
            // disabled
            format="M/D/YY - dddd"
            style={{ width: "100%" }}
            minDate={dayjs("2025-01-01")}
            defaultValue={getNow()}
          />
          <TimePicker.RangePicker
            format={STANDARD_TIME_FORMAT}
            // disabled
            use12Hours={false}
            minuteStep={5}
            hideDisabledOptions
            needConfirm={false}
            cellRender={(current, info) => {
              // Time picker labels are numbers not dates
              const typesafeCurrent = Number(current)
              // Reformat 24h time into 12h time so we don't need to show AM/PM
              if (info.subType === "hour") {
                const hour12 = ((typesafeCurrent + 11) % 12) + 1
                return cloneElement(info.originNode, {}, `${hour12}`)
              }
              return info.originNode
            }}
            disabledTime={() => ({
              disabledHours: () => disabledHours,
            })}
            defaultValue={[getNow(), getNow().add(1, "hour")]}
          />
        </Flex>
      </AntdSection>

      <AntdSection title="Color picker">
        <ColorPicker
          defaultValue={"#B00"}
          allowClear
          showText
          mode={["single", "gradient"]}
          onChangeComplete={(color) => {
            console.log(color.toCssString())
          }}
        />
      </AntdSection>

      <AntdSection title="QR Code">
        <QRCode value="https://ant.design/" />
      </AntdSection>

      <AntdSection title="Slider">
        <Slider defaultValue={30} style={{ width: 300 }} />
      </AntdSection>

      <AntdSection title="Switch">
        <Switch />
        <Switch checked loading />
        <Switch disabled />
        <Switch checked disabled />
      </AntdSection>
    </Flex>
  )
}

export default AntdForms
